import { Typography } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { getPercent } from '@/shared/lib/getPercent';

import { SBarContainer, SContainer, SContent, SHint, SProgress, SUsed } from './styled';

type UsageBarProps = {
  label: string;
  hint?: string;
  total: number;
  type?: 'min' | 'videos';
  used: number;
};

export const UsageBar = ({ label, hint, total, type, used }: UsageBarProps) => {
  const { t } = useInterfaceLanguage();
  const usageText =
    type === 'videos'
      ? t('account.credits.usageVideos', { left: total - used, used })
      : t('account.credits.usageMinutes', { left: total - used, used });

  return (
    <SContainer>
      <SContent>
        <Typography color="grey.900" variant="body-1-md">
          {label}
        </Typography>
        {type && (
          <SUsed color="grey.900" variant="body-2-md">
            {usageText}
          </SUsed>
        )}
      </SContent>

      <SBarContainer>
        <SProgress value={getPercent(used, total)} />
      </SBarContainer>

      {hint && (
        <SHint color="grey.500" variant="caption-1">
          {hint} {t('account.credits.rolloverHint')}
        </SHint>
      )}
    </SContainer>
  );
};
